import { InMemoryCache } from '@apollo/client';
import { ApolloClient } from 'apollo-client';
import Q from 'q';

import { getIetfLanguageTag } from 'js/lib/language';
import { tupleToStringKey } from 'js/lib/stringKeyTuple';

import GetProductOwnership from 'bundles/entitlements-common/queries/GetProductOwnershipQuery.graphql';
import { formatGraphqlProductOnwership } from 'bundles/entitlements-common/utils/entitlementProductOwnershipUtils';
import { VERIFIED_CERTIFICATE } from 'bundles/payments-common/common/ProductType';
import ProductOwnership from 'bundles/product/models/productOwnership';

export default function (userId: number, courseId: string, rawData: boolean) {
  const productOwnershipId = tupleToStringKey([userId, VERIFIED_CERTIFICATE, courseId]);
  const cache = new InMemoryCache();
  const client = new ApolloClient({
    uri: `/graphql-gateway?opname=GetProductOwnership`,
    cache,
    headers: {
      'Accept-Language': getIetfLanguageTag(),
    },
  });

  return Q(
    client
      .query({
        query: GetProductOwnership,
        variables: {
          productOwnershipId,
        },
        context: { clientName: 'gatewayGql' },
      })
      .then(({ data }) => {
        const formattedData = formatGraphqlProductOnwership(data?.Entitlement?.queryProductOwnership);

        if (rawData) {
          return formattedData;
        }

        return new ProductOwnership(formattedData, { parse: true });
      })
  );
}
